import React, { Fragment } from "react";
import {
  Page,
  Document,
  Image,
  StyleSheet,
  Text,
  Font,
  View,
} from "@react-pdf/renderer";

import logo from "assets/images/logo.png";

import allfont from "../../../../assets/fonts/ZCOOL_XiaoWei/ZCOOLXiaoWei-Regular.ttf";
import notoSans from "../../../../assets/fonts/NotoSans/NotoSansSC-Regular.ttf";
//import allfont from "../../../../assets/fonts/oswald/Oswald-Regular.ttf";

//font-family: 'Noto Sans', 'Noto Sans JP', sans-serif;
//Oswald-Regular
import default_logo from "assets/images/headerLogo.png";
import { treatmentHistory } from "component/Admin/Customer/CustomerDetails/TreatmentHistory";

Font.register({
  family: "ZCOOL XiaoWei",
  //family: "Oswald",
  src: allfont,
});
Font.register({
  family: "NotoSans",
  src: notoSans,
});

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  page: {
    minWidth: "72.1mm",
    maxWidth: "72.1mm",
    padding: 15,
    //fontFamily: "Oswald",
    fontFamily: "NotoSans",
  },
  section: {
    color: "black",
    textAlign: "center",
    marginBottom: 2,
  },
  headerTitle: {
    fontSize: 12.5,
    //fontWeight: 700, //Yoonus
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 10,
    //fontWeight: 400, //Yoonus
    marginBottom: 10,
    lineHeight: 1.2,
  },
  tableHeader: {
    flexDirection: "row",
    // textAlign: "center",
    fontSize: "11px",
    padding: "10px 0px",
  },
  tableBody: {
    flexDirection: "row",
    textAlign: "center",
    fontSize: "10px",
  },
  courseContainer: {
    flexDirection: "row",
    fontSize: "10px",
  },
  receipt: {
    textAlign: "center",
    fontSize: 10,
    marginBottom: 10,
  },
  qty: {
    fontSize: 9,
    //fontWeight: "normal", //Yoonus
    width: "12%",
    padding: "1px",
  },
  description: {
    fontSize: 9,
    //fontWeight: "normal", //Yoonus
    width: "60%",
    textAlign: "left",
    padding: "1px",
  },
  tablePayment: {
    fontSize: 9,
    //fontWeight: "normal", //Yoonus
    width: "28%",
    textAlign: "right",
  },

  descriptionSubTotal: {
    width: "70%",
    textAlign: "left",
    padding: "1px",
    fontSize: "10px",
    marginVertical: 3,
  },
  descriptionTotal: {
    width: "70%",
    textAlign: "left",
    padding: "1px",
    fontSize: "13px",
    //fontWeight: "semibold", //Yoonus
  },
  descriptionCourse: {
    width: "72%",
    textAlign: "left",
    padding: "1px",
  },
  paymentCourse: {
    width: "23%",
    padding: "1px",
  },
  payment: {
    width: "23%",
    padding: "1px",
  },
  Total: {
    width: "50%",
    padding: "1px",
    fontSize: "11px",
    textAlign: "right",
  },
  subTotal: {
    textAlign: "right",
    fontSize: 10,
    marginBottom: 7,
  },
  memberInfo: {
    textAlign: "left",
    fontSize: 10,
    marginBottom: 4,
  },
  loginInfo: {
    borderTop: "2px dotted",
    borderTopWidth: 1,
    borderTopStyle: "dashed",
    padding: "10px 0px",
  },
  thankYouData: {
    fontSize: 11,
    textAlign: "center",
    //fontWeight: 700, //Yoonus
    paddingTop: 1,
    paddingBottom: 1,
  },

  logo: {
    maxWidth: "100%",
    height: "80px",
  },

  // prepaidContainer
  prepaidContainer: {
    display: "flex",
    flexDirection: "row",
  },
  width60: {
    width: "60%",
  },
  width40: {
    width: "40%",
  },
  titlecontainer: {
    fontSize: 11,
    //fontWeight: 500, //Yoonus
    //fontWeight: "bold", //Yoonus
    textAlign: "center",
  },
  prepaidBorder: {
    borderTop: 1,
    borderStyle: "dotted",
  },
  desTitle: {
    fontSize: 8,
    textAlign: "center",
    lineHeight: 1.5,
  },
  desBalance: {
    fontSize: 8,
    textAlign: "center",
  },
  marginVertical4: {
    marginVertical: 4,
  },
  footerContainer: {
    paddingTop: 10,
    paddingBottom: 3,
    borderBottomWidth: 1,
    borderBottomStyle: "dashed",
  },

  footerData: {
    textAlign: "center",
    fontSize: 10,
    //fontWeight: 600, //Yoonus
    //marginBottom: 1, //1 Yoonus
  },
  thankYou: {
    marginTop: 1,

    paddingVertical: 1,
  },

  // consultContainer
  consultContainer: {
    paddingVertical: 5,
  },
  consultTitle: {
    fontSize: 8,
    //fontWeight: "normal", //Yoonus
    marginVertical: 1,
  },
  borderTopCommon: {
    borderTop: "2px dotted",
    borderTopWidth: 1,
    borderTopStyle: "dashed",
    marginVertical: 2,
  },
  dummySpace: {
    paddingVertical: 5,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  marginVeriticalCommon: {
    marginVertical: 2,
  },
  textalignCommonCenter: {
    textAlign: "center",
  },
  textalignCommonRight: {
    textAlign: "right",
  },
  // courseTable
  width75: {
    width: "75%",
  },
  width25: {
    width: "25%",
  },
  paymentType: {
    fontSize: "10px",
    marginBottom: 7,
  },
  fontSize11: {
    fontSize: 11,
  },
  marginTop3: {
    marginTop: 5,
  },
});

export class Coulisseheir extends React.Component {
  render() {
    let {
      accountHeader,
      responseData,
      Flag,
      landscape = false,
      currency,
    } = this.props;
    console.log(responseData, "responseData");
    let {
      hdr_data = [],
      dtl_data = [],
      sub_data = {},
      taud_data = [],
      footer = {},
      company_hdr = {},
      taud_sub = {},
    } = responseData;
    console.log(hdr_data, "hdrData");
    let {
      showprepaid,
      prepaidlst,
      treatment = [],
      treatmentbal = false,
    } = footer;
    console.log(footer, "footerData");
    //getTotalAmount

    const getTotalCount = () => {
      if (dtl_data) {
        var totalCount = dtl_data.reduce(
          (total, item) => total + item.dt_qty,
          0
        );
      }
      console.log(dtl_data, "detailData");
      return totalCount;
    };

    return (
      <Document file="somefile.pdf">
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            {accountHeader?.logo ? (
              <Image style={styles.logo} source={{ uri: accountHeader.logo }} />
            ) : (
              <Image
                style={styles.logo}
                source={require(`../../../../assets/images/headerLogo.png`)}
              />
            )}
            <View style={styles.headerText}>
              {/*Yoonus open up for thelohasians*/}
              {/* <Text style={styles.headerTitle}>
                {accountHeader?.name ? accountHeader?.name : "Beautesoft"}
              </Text> */}
              { <Text style={styles.subtitle}>
                {accountHeader?.name ? accountHeader?.name : "Beautesoft"}
              </Text> }
              <Text style={styles.subtitle}>
              {/*accountHeader?.name ? accountHeader?.name : "Beautesoft"*/}
              {/*accountHeader?.address
                ? accountHeader?.address
                  : "211 Holland Ave, Holland Road Shopping Center #0343 Singapore 278969 Apt: 6469 9141 | Whatsapp: 8121 4779"*/}
              {accountHeader?.address
                ? accountHeader?.address
                  : ""}
              </Text>
            </View>
          </View>
          <View>
            {company_hdr?.gst_reg_no !== "" && (
              <Text style={styles.footerData}>
                Gst Reg No: {company_hdr?.gst_reg_no}
              </Text>
            )}
            {hdr_data?.invoice_header && (
              <Text style={styles.footerData}>{hdr_data?.invoice_header}</Text>
            )}
            <Text style={styles.footerData}>
              Reciept: {hdr_data ? hdr_data?.trans : "N/A"}
            </Text>
            {hdr_data?.void_refno !== "" && (
              <Text style={styles.footerData}>
                Void Reciept: {hdr_data?.void_refno}
              </Text>
            )}
          </View>
          <View style={styles.tableHeader}>
            <Text style={styles.qty}>{`Qty`}</Text>
            <Text style={styles.description}>{`Item`}</Text>
            <Text
              style={[styles.tablePayment, styles.textalignCommonCenter]}
            >{`Amt`}</Text>
          </View>
          <View style={styles.borderTopCommon} />

          {dtl_data?.length > 0 &&
            dtl_data?.map((item, index) => {
              return (
                <View key={index}>
                  <View style={styles.tableBody}>
                    <Text style={styles.qty}>{item?.dt_qty}</Text>
                    <Text style={styles.description}>{item?.dt_itemdesc}</Text>
                    {item?.dt_deposit !== null &&
                      item?.dt_deposit !== undefined &&
                      item?.dt_deposit !== "" && (
                        <Text style={styles.tablePayment}>
                          {currency}&nbsp;{item?.dt_deposit}
                        </Text>
                      )}
                  </View>
                  <View style={styles.consultContainer}>
                    {item &&
                      item.sales_staff !== undefined &&
                      item.sales_staff !== " " && (
                        <Text
                          style={[styles.consultTitle, { marginBottom: 0 }]}
                        >
                          Sold By: <Text>{item.sales_staff}</Text>
                        </Text>
                      )}

                    {item &&
                      item.work_staff !== undefined &&
                      item.work_staff !== " " && (
                        <Text style={[styles.consultTitle]}>
                          Service By: <Text>{item.work_staff}</Text>
                        </Text>
                      )}
                  </View>
                </View>
              );
            })}
          {/* <View style={styles.borderTopCommon} /> */}
          <View style={styles.loginInfo}>
            <View style={styles.tableBody}>
              <Text style={styles.descriptionSubTotal}>{`Sub Total`}</Text>
              {sub_data?.sub_total && (
                <Text style={styles.Total}>
                  {" "}
                  {currency}&nbsp;
                  {sub_data?.sub_total}
                </Text>
              )}
            </View>
            <View style={styles.tableBody}>
              <Text style={styles.descriptionSubTotal}>{`${
                currency === "$" ? "GST" : "Tax"
              }`}</Text>

              <Text style={styles.Total}>
                {" "}
                {currency}&nbsp;
                {taud_sub?.gst ? taud_sub?.gst : "0.00"}
              </Text>
            </View>
            <View style={styles.tableBody}>
              <Text style={styles.descriptionTotal}>{`Total`}</Text>
              {taud_sub?.grand_tot && (
                <Text style={styles.Total}>
                  {" "}
                  {currency}&nbsp;
                  {taud_sub?.grand_tot}
                </Text>
              )}
            </View>
            <View style={styles.marginTop3}>
              <Text style={styles.descriptionSubTotal}>{`Payment Type :`}</Text>
            </View>
          </View>

          <View style={styles.loginInfo}>
            {taud_data &&
              taud_data.length > 0 &&
              taud_data.map((item, index) => {
                return (
                  <View style={styles.courseContainer} key={index}>
                    <Text
                      style={[styles.paymentType, styles.width75]}
                      key={index + 1}
                    >
                      {item?.pay_type_name}
                    </Text>
                    <Text
                      style={[
                        styles.paymentType,
                        styles.width40,
                        styles.textalignCommonRight,
                      ]}
                      key={index}
                    >
                      {currency}&nbsp;{item?.pay_amt}
                    </Text>
                  </View>
                );
              })}
          </View>

          {treatmentbal && (
            <View>
              <View style={styles.borderTopCommon} />
              <View style={styles.tableHeader}>
                <Text style={styles.descriptionCourse}>{`Course`}</Text>
                <Text style={styles.paymentCourse}>{`Count`}</Text>
              </View>
              <View style={styles.borderTopCommon} />
            </View>
          )}
          {treatmentbal &&
            treatment &&
            treatment?.length > 0 &&
            treatment?.map((item, index) => {
              return (
                <View key={index}>
                  <View style={styles.courseContainer}>
                    <Text style={[styles.descriptionCourse]}>
                      {item?.course}
                    </Text>
                    {item?.total && (
                      <Text
                        style={[
                          styles.payment,
                          styles.paymentCourse,
                          styles.textalignCommonRight,
                        ]}
                      >
                        {" "}
                        {item?.total}
                      </Text>
                    )}
                  </View>
                </View>
              );
            })}

          {/* <View style={styles.dummySpace} /> */}
          <View style={styles.borderTopCommon} />

          <View style={styles.consultContainer}>
            <Text style={styles.consultTitle}>
              Customer :{" "}
              <Text>
                {hdr_data?.sa_custname}{" "}
                {hdr_data?.cust_phone2 && `(${hdr_data?.cust_phone2})`}{" "}
              </Text>
            </Text>
            <View style={styles.itemContainer}>
              <Text style={styles.consultTitle}>
                Item Qty : <Text>{dtl_data && getTotalCount(dtl_data)}</Text>
              </Text>
              {/* {hdr_data?.issued && (
                <Text style={styles.consultTitle}>
                  Cashier : <Text>{hdr_data ? hdr_data?.issued : ""}</Text>
                </Text>
              )} */}
            </View>

            <Text style={styles.consultTitle}>
              Date :{" "}
              <Text>
                {hdr_data?.sa_date} {hdr_data?.sa_time}
              </Text>
            </Text>
            {footer && footer?.footer1.trim() !== "" && (
              <Text style={styles.consultTitle}>{footer.footer1}</Text>
            )}
            {footer && footer?.footer2.trim() !== "" && (
              <Text style={styles.consultTitle}>{footer.footer2}</Text>
            )}
            {footer && footer?.footer3.trim() !== "" && (
              <Text style={styles.consultTitle}>{footer.footer3}</Text>
            )}
          </View>
          <View style={styles.thankYou}>
            <Text style={styles.thankYouData}>Thank You, See You Again!</Text>
          </View>
        </Page>
      </Document>
    );
  }
}
export default Coulisseheir;
